import {Component, OnInit} from '@angular/core';
//import { AuthServicesService } from 'mclane-webauth-lib';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import {WindowService} from '@progress/kendo-angular-dialog';
import { LoggingService, MenuService} from 'mclane-apptemplate-lib';
import {environment} from '../environments/environment';
import {ErrorApiService} from "~/app/test/error-api.service";
import { LoadingIndicatorHelper } from './core/services/loading-indicator-helper';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  env = environment;
  title = 'application';
  breadcrumb: 'Statements';
  windowService: WindowService;

  ngOnInit() {
  }

  constructor(private router: Router,
              private route: ActivatedRoute,
              private activatedRoute: ActivatedRoute,
              ws: WindowService,
              private ms: MenuService,
              public errorApiService: ErrorApiService,
              private console: LoggingService,
              public loadingIndicator: LoadingIndicatorHelper
  ) {
    this.windowService = ws;
  }

  generateBreadcrumb(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    if (activatedRouteSnapshot != null && !(typeof activatedRouteSnapshot === 'undefined') && (activatedRouteSnapshot.routeConfig as any).data !== undefined) {
      let ret = (activatedRouteSnapshot.routeConfig as any).data.text;
      if (activatedRouteSnapshot.root.data != null && !(typeof activatedRouteSnapshot.root.data[0] === 'undefined')) {
        ret = (ret ? `${ret} / ` : '') + this.generateBreadcrumb(activatedRouteSnapshot.root.data[0]);
      }
      return ret;
    }
  }

  public onSelect({item}): void {
    if (!item.items) {
      if (item.path) {
        this.router.navigate([item.path]);
      } else if (item.action) {
        item.action(this);
      }
    }
  }

  test400() {
    this.loadingIndicator.show();
    this.errorApiService.test400().then(() => {
    });
  }

  test401() {
    this.loadingIndicator.show();
    this.errorApiService.test401().then(() => {
    });
  }

  test403() {
    this.loadingIndicator.show();
    this.errorApiService.test403().then(() => {
    });
  }

  test404() {
    this.loadingIndicator.show();
    this.errorApiService.test404().then(() => {
    });
  }

  test500() {
    this.loadingIndicator.show();
    this.errorApiService.test500().then(() => {
    });
  }

  throwSplunkErrorAPI() {
    this.errorApiService.testSplunk().then(() => {
    });
  }


  logout() {
    //this.Auth.logout('http:localhost:4300');
  }

}

